var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",style:({backgroundImage: ("url('" + _vm.background + "')")})},[_c(_vm.layout,{key:_vm.layout,tag:"component"},[_c('router-view')],1),_c('notifications',{attrs:{"classes":"notify","position":"top right"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }